<div dropdown keyboard-nav="true" class="dropdown">
  <button
    dropdownToggle
    class="btn btn-lg btn-lg--fa-square btn-link qa-reading-intention-dropdown"
    data-bs-toggle="dropdown"
    type="button"
    title="Reading intentions menu"
    i18n-title="@@readingIntentionsMenu-title-readingIntentionsMenu"
  >
    <i
      [ngClass]="[intention.icon || '', 'qa-status--' + intention.className]"
      class="fa-fw status-selection__indicator a-fade-in"
      aria-hidden="true"
    ></i>
    <span
      i18n="@@readingIntentionsMenu-btn-readingIntentionToggle"
      class="sr-only"
    >
      Reading intention: {intention.value, select, Undecided {Undecided}
      PlanToConsume {Will read} CurrentlyConsuming {Reading now} HaveConsumed
      {Have read} DecidedNotToConsume {Won't read}}
    </span>
  </button>

  <ul *dropdownMenu class="dropdown-menu dropdown-menu-end">
    <li
      *ngFor="let intention of intentions"
      [ngClass]="['status--' + intention.className]"
    >
      <button
        (click)="
          canUpdateReadingIntention && onReadingIntentionChange(intention)
        "
        [disabled]="!canUpdateReadingIntention"
        [ngClass]="['qa-' + intention.className, 'qa-reading-intention-btn']"
        class="dropdown-item"
        [class.disabled]="!canUpdateReadingIntention"
        type="button"
      >
        <i
          [ngClass]="intention.icon"
          class="intentions__icon fa-fw"
          aria-hidden="true"
        ></i>
        <span class="intentions__text">
          <ng-container [ngSwitch]="intention.value">
            <ng-container
              *ngSwitchCase="ReadingIntentionsKey.Undecided"
              i18n="@@readingIntentionsMenu-btn-undecided"
              >Undecided</ng-container
            >
            <ng-container
              *ngSwitchCase="ReadingIntentionsKey.PlanToConsume"
              i18n="@@readingIntentionsMenu-btn-willRead"
              >Will read</ng-container
            >
            <ng-container
              *ngSwitchCase="ReadingIntentionsKey.CurrentlyConsuming"
              i18n="@@readingIntentionsMenu-btn-readingNow"
              >Reading now</ng-container
            >
            <ng-container
              *ngSwitchCase="ReadingIntentionsKey.HaveConsumed"
              i18n="@@readingIntentionsMenu-btn-haveRead"
              >Have read</ng-container
            >
            <ng-container
              *ngSwitchCase="ReadingIntentionsKey.DecidedNotToConsume"
              i18n="@@readingIntentionsMenu-btn-wontRead"
              >Won't read</ng-container
            >
          </ng-container>
        </span>
      </button>
    </li>
  </ul>
</div>
